import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components';
import {AmountControl, AutocompleteControl, BaseControl, SelectControl} from '../../../app/shared/classes';

export const WithdrawalAccountFromSelector = 'accountFrom';
export const WithdrawalLinkedAccountToSelector = 'linkedAccountTo';
export const WithdrawalAccountToSelector = 'accountTo';
export const WithdrawalAmountSelector = 'amount';
export const WithdrawalCurrencySelector = 'currency';
export const BankAccountWithdrawalAvailableCurrencies = ['USD', 'EUR'];
export const WithdrawalComponentControls = (): BaseControl<string | number>[] => {
    return [
        new BaseControl({
            name: WithdrawalAccountFromSelector,
            value: null,
            placeholder: 'Account From',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
            readonly: true
        }),
        new AutocompleteControl({
            name: WithdrawalLinkedAccountToSelector,
            value: null,
            placeholder: 'Account To',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: []
        }),
        new AutocompleteControl({
            name: WithdrawalAccountToSelector,
            value: null,
            placeholder: 'Account To',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: []
        }),
        new AmountControl({
            name: WithdrawalAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: ''
        }),
        new SelectControl({
            name: WithdrawalCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
    ];
};

export const WithdrawalDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: true
    };
};
